// extracted by mini-css-extract-plugin
export var content = "styles-module--content--0e7b9";
export var form = "styles-module--form--9c893";
export var success = "styles-module--success--e801f";
export var title = "styles-module--title--f0513";
export var wrapper = "styles-module--wrapper--1a9a9";